const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      { component: "search-disaster-types", label: "재해형태", value: "disaster", query: { dty: "disaster" }, options: {} },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          // 회사명만 남기고 나머지는 addList 로 순서를 다시 지정한다 (회사명-참석자명-구분-교육일-교육 실시 인원)
          hiddenList: ["구분", "교육일", "재해형태", "교육 실시 인원", "작성일"],
          addList: ["참석자명", "구분", "교육일", "교육 실시 인원"],
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({ key: "body.reflected_disaster_type[%]", operator: "LIKE", value: `%${search.disaster}%` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      if (search.column.head === "참석자명") {
        // 참석자 명단(등록 종사자) + 시스템 미등록 참석자 명단의 성명을 모아둔 검색용 배열(body.participantNames)에서 검색한다.
        conditions.push({ key: "body.participantNames[%]", operator: "LIKE", value: `%${search.column.keyword}%` });
      } else {
        conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
      }
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "회사명", key: "body.stdInfo.field_name" },
      { name: "구분", key: "body.education_type" },
      { name: "교육일", key: "body.education_date" },
      { name: "재해형태", key: "body.reflected_disaster_type" },
      { name: "교육 실시 인원", key: "body.participants_attended" },
      { name: "작성일", key: "created_at" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 회사명
        case 1:
          return func.getContent(value).education_type || ""; // 교육구분
        case 2:
          return func.getContent(value).education_date; // 교육일
        case 3:
          return func.getContent(value).reflected_disaster_type.join(", "); // 재해형태
        case 4:
          return func.comma(func.getContent(value).participants_attended); // 교육실시인원
        case 5:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
